import { isPlatformBrowser, Location } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Router,
} from '@angular/router';
import { StorageMap } from '@ngx-pwa/local-storage';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoginComponent } from 'src/app/dialogs/login/login.component';
import { SignupDialog } from 'src/app/dialogs/signup/signup.dialog';
import { SearchInfo } from 'src/app/models/search-info';
import { User } from 'src/app/models/user';
import { AuthcheckService } from 'src/app/services/authcheck.service';
import { FavoriteService } from 'src/app/services/favorite.service';
import { TokenService } from 'src/app/services/token.service';
import { TolisDialogService } from 'src/app/dialogs/tolis-dialog/tolis-dialog.service';
import { environment } from 'src/environments/environment';
import {
  LocationSelection,
  LocationTypeaheadComponent,
} from 'src/app/shared/components/location-typeahead/location-typeahead.component';
import { CalendarOptions } from 'src/app/shared/components/inline-calendar/inline-calendar.component';
import {
  Guests,
  GuestType,
} from 'src/app/shared/components/guest-picker/guest-picker.types';
import { DEFAULT_LOCATION_EMPTY_STATE_SUGGESTIONS } from 'src/app/shared/services/location-default-suggestions';
import { SearchDialogService } from 'src/app/services/search-dialog.service';

@Component({
  selector: 'app-layout-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class HeaderComponent implements OnInit, OnDestroy {
  // @ViewChild('loginRef', { static: true }) loginElement: ElementRef;
  @ViewChild('searchboxTop', { static: true }) searchboxTop: ElementRef;
  @ViewChild('openSignUpBtn') private _origin: ElementRef;
  @ViewChild('desktopWhereTypeahead')
  desktopWhereTypeahead?: LocationTypeaheadComponent;
  @Input() showBack: boolean;
  @Output() valueChange = new EventEmitter();

  allLogos: string[] = [
    '2.png',
    '3.png',
    '4.png',
    '6.png',
    '7.png',
    '13.png',
    '26.png',
    '28.png',
    '42.svg',
    '46.png',
    '1522-SunBg.png',
    // 'Ocean.png',
    'Starfish40x40-full.png',
    'Sticker-06.png',
    'Sticker-08.png',
    'suitcase48.png',
    'Summer06182205.jpg',
    // 'suncharacter48.png',
    'Suitcase-sm.png',
    'summer-12.png',
    'summer-14.png',
  ];

  logoImage: string;

  searchForm: UntypedFormGroup;
  searchInformation: SearchInfo = new SearchInfo();
  queryParamsSubscription: Subscription;
  searchboxValueSubscription?: Subscription;
  mobileSearchExpanded = false;

  headerEmptyStateSuggestions: LocationSelection[] = [
    ...DEFAULT_LOCATION_EMPTY_STATE_SUGGESTIONS,
  ] as LocationSelection[];

  activeMobileSearchPanel: 'where' | 'when' | 'who' = 'where';
  activeDesktopSearchPanel: 'where' | 'when' | 'who' | null = null;
  mobileGuests: GuestType = new Guests();
  mobileStartDate: Date | null = null;
  mobileEndDate: Date | null = null;
  draftStartDate: Date | null = null;
  draftEndDate: Date | null = null;
  dateFlexibility = 0;
  flexibilityOptions = [
    { days: 0, label: 'Exact' },
    { days: 1, label: '± 1 day' },
    { days: 2, label: '± 2' },
    { days: 3, label: '± 3' },
    { days: 7, label: '± 7' },
  ];
  mobileCalendarOptions: CalendarOptions = {
    showTitle: false,
    multiple: true,
    minstays: [],
  };

  auth2: any;
  apiUrl: string;
  favorites = [];
  previousUrl = '';

  public loggedIn: boolean;
  public user = new User({});
  public autocompleteOptions = {
    types: [],
    componentRestrictions: { country: 'CY' },
  };
  // Private
  private placeId: string = '';
  private selectedLocation: LocationSelection | null = null;
  private unsubscribeAll: Subject<any> = new Subject<any>();
  private unsubscribeFavs: Subject<any> = new Subject<any>();
  private suppressNextOutsideClick = false;
  searchSubmitPulse = false;
  private searchSubmitPulseTimer?: ReturnType<typeof setTimeout>;

  constructor(
    private authCheckService: AuthcheckService,
    private tokenService: TokenService,
    private storage: StorageMap,
    private favoriteService: FavoriteService,
    private router: Router,
    private location: Location,
    @Inject(PLATFORM_ID) private platformId: {},
    private formBuilder: UntypedFormBuilder,
    private ref: ChangeDetectorRef,
    private route: ActivatedRoute,
    private _tolisDialogService: TolisDialogService,
    private searchDialogService: SearchDialogService,
  ) {
    this.previousUrl = '/';
    // !router.getCurrentNavigation().previousNavigation ? '/' : router.getCurrentNavigation().previousNavigation.initialUrl.toString();

    this.showBack = false;
    this.logoImage =
      this.allLogos[Math.floor(Math.random() * this.allLogos.length)];
  }

  onBackClick(): void {
    if (this.previousUrl === '/') {
      this.router.navigateByUrl(this.previousUrl);
    } else {
      this.location.back();
    }
  }

  ngOnInit(): void {
    this.searchForm = this.formBuilder.group({
      searchbox: [''],
    });

    this.searchDialogService.open$
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe(() => {
        this.openMobileSearch();
      });

    this.syncSearchStateFromParams(this.route.snapshot.queryParams);
    this.queryParamsSubscription = this.route.queryParams.subscribe(
      (params) => {
        this.syncSearchStateFromParams(params);
      },
    );
    this.searchboxValueSubscription = this.searchForm
      .get('searchbox')
      ?.valueChanges.subscribe((value: string) => {
        const typedValue = String(value || '')
          .trim()
          .toLowerCase();
        const selectedValue = String(this.selectedLocation?.name || '')
          .trim()
          .toLowerCase();

        if (!typedValue || (selectedValue && typedValue !== selectedValue)) {
          this.selectedLocation = null;
          this.placeId = '';
        }
      });

    this.apiUrl = environment.endpoints.api;

    if (isPlatformBrowser(this.platformId)) {
      // Set the logged in status
      const self = this;
      this.storage.get('favorites').subscribe((data: any[]) => {
        this.favorites = data ? data : [];
      });

      this.favoriteService.observer
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe((value) => {
          this.storage.get('favorites').subscribe((data: any[]) => {
            this.favorites = data ? data : [];
          });
        });

      this.authCheckService.authStatus.subscribe((value) => {
        if (!this.user) {
          this.user = new User({});
        }

        this.loggedIn = value;

        if (this.loggedIn) {
          const user = JSON.parse(localStorage.getItem('currentUser'));
          user.avatarUrl =
            environment.endpoints.storage +
            '/avatars/' +
            user.id +
            '/avatar.jpg';

          this.user = user;
        }
      });
    }
  }

  onLocationSelected(selection: LocationSelection): void {
    // If a specific property is selected, navigate directly to its page
    if (selection.type === 'property' && selection.id) {
      const slug =
        selection.name
          ?.toLowerCase()
          .replace(/\s+/g, '-')
          .replace(/[^\w-]/g, '') || 'property';
      this.router.navigateByUrl(`/rental/${selection.id}/${slug}`);
      return;
    }

    this.selectedLocation = selection;
    this.placeId = '';
    this.searchForm.get('searchbox')?.setValue(selection.name);
    this.activeDesktopSearchPanel = 'when';
  }

  setActiveDesktopPanel(panel: 'where' | 'when' | 'who'): void {
    this.activeDesktopSearchPanel = panel;
    if (panel === 'where') {
      setTimeout(() => this.desktopWhereTypeahead?.focusInput(), 50);
    }
  }

  openMobileSearch(): void {
    this.mobileSearchExpanded = true;
    this.activeMobileSearchPanel = 'where';
    this.setHeaderMobileSearchBodyState(true);
    this.hideOffcanvasPanel();
  }

  closeMobileSearch(): void {
    this.mobileSearchExpanded = false;
    this.activeMobileSearchPanel = 'where';
    this.setHeaderMobileSearchBodyState(false);
  }

  setActiveMobilePanel(panel: 'where' | 'when' | 'who'): void {
    this.mobileSearchExpanded = true;
    this.activeMobileSearchPanel = panel;
  }

  onMobileLocationSelected(selection: LocationSelection): void {
    this.selectedLocation = selection;
    this.placeId = '';
    this.searchForm.get('searchbox')?.setValue(selection.name);
    this.activeMobileSearchPanel = 'when';
  }

  private triggerSearchSubmitPulse(): void {
    if (this.searchSubmitPulseTimer) {
      clearTimeout(this.searchSubmitPulseTimer);
    }

    this.searchSubmitPulse = false;
    setTimeout(() => {
      this.searchSubmitPulse = true;
      this.searchSubmitPulseTimer = setTimeout(() => {
        this.searchSubmitPulse = false;
      }, 1150);
    }, 0);
  }

  onMobileDatesSelected(range: { from: string; to: string }): void {
    // Update draft dates (temporary, not committed until Search is clicked)
    this.draftStartDate = range?.from ? new Date(range.from) : null;
    this.draftEndDate = range?.to ? new Date(range.to) : null;

    if (this.draftStartDate && this.draftEndDate) {
      this.triggerSearchSubmitPulse();
    }

    this.activeMobileSearchPanel = 'when';
    this.activeDesktopSearchPanel = 'when';
    this.suppressNextOutsideClick = true;
  }

  onMobileGuestsChanged(guests: GuestType): void {
    this.mobileGuests = guests;
  }

  onDesktopDatesNext(): void {
    if (!this.mobileStartDate || !this.mobileEndDate) {
      return;
    }

    this.activeDesktopSearchPanel = 'who';
  }

  setDateFlexibility(days: number): void {
    this.dateFlexibility = days;

    if (this.isSearchRoute()) {
      const nextQueryParams = {
        ...this.route.snapshot.queryParams,
        dateFlexibility: days,
        page: 1,
        nextPage: 1,
      };

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: nextQueryParams,
      });
    }
  }

  clearMobileSearch(): void {
    this.selectedLocation = null;
    this.placeId = '';
    this.searchForm.reset({ searchbox: '' });
    this.mobileGuests = new Guests();
    this.mobileGuests.adults = 2;
    this.mobileStartDate = null;
    this.mobileEndDate = null;
    this.draftStartDate = null;
    this.draftEndDate = null;
    this.dateFlexibility = 0;
    this.activeMobileSearchPanel = 'where';
    this.activeDesktopSearchPanel = 'where';
  }

  getMobileWhereSummary(): string {
    return this.getWhereSummary();
  }

  getMobileWhenSummary(): string {
    return this.getWhenSummary();
  }

  getMobileWhoSummary(): string {
    const totalGuests = this.getTotalGuests();

    if (totalGuests <= 0) {
      return 'Add guests';
    }

    return `${totalGuests} guest${totalGuests === 1 ? '' : 's'}`;
  }

  getDesktopWhereSummary(): string {
    return this.getWhereSummary();
  }

  getDesktopWhenSummary(): string {
    return this.getWhenSummary();
  }

  getWhenFlexibilitySummary(): string {
    return this.dateFlexibility > 0 ? `±${this.dateFlexibility}` : '';
  }

  isHomeRoute(): boolean {
    const currentUrl = this.router.url || '';
    return currentUrl === '/' || currentUrl.startsWith('/?');
  }

  isSearchRoute(): boolean {
    const currentUrl = this.router.url || '';
    return currentUrl.startsWith('/search/');
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.mobileSearchExpanded || !this.activeDesktopSearchPanel) {
      return;
    }

    if (this.suppressNextOutsideClick) {
      this.suppressNextOutsideClick = false;
      return;
    }

    const target = event.target as HTMLElement;
    if (
      target.closest('.header-search') ||
      target.closest('.cdk-overlay-pane') ||
      target.closest('.cdk-overlay-container')
    ) {
      return;
    }

    // If dates were selected, auto-search when clicking outside
    if (this.draftStartDate && this.draftEndDate) {
      this.onSubmit();
      return;
    }

    // Otherwise just close the panel
    this.activeDesktopSearchPanel = null;
  }

  /**
   * On Submit
   */
  private closeOffcanvas(): void {
    this.mobileSearchExpanded = false;
    this.activeMobileSearchPanel = 'where';
    this.activeDesktopSearchPanel = null;
    this.setHeaderMobileSearchBodyState(false);
    this.hideOffcanvasPanel();
  }

  private setHeaderMobileSearchBodyState(open: boolean): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    document.body.classList.toggle('header-mobile-search-open', open);
  }

  private hideOffcanvasPanel(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const offcanvasEl = document.getElementById('offcanvasNavbar2');
    if (offcanvasEl) {
      const bsOffcanvas = (window as any)?.bootstrap?.Offcanvas?.getInstance(
        offcanvasEl,
      );
      if (bsOffcanvas) {
        bsOffcanvas.hide();
      } else {
        // Fallback: manually clean up Bootstrap's overflow lock
        document.body.classList.remove('offcanvas-backdrop');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        offcanvasEl.classList.remove('show');
        const backdrop = document.querySelector('.offcanvas-backdrop');
        if (backdrop) backdrop.remove();
      }
    }
  }

  onSubmit(): void {
    // Commit draft dates to main dates when Search is clicked
    if (this.draftStartDate && this.draftEndDate) {
      this.mobileStartDate = this.draftStartDate;
      this.mobileEndDate = this.draftEndDate;
      this.draftStartDate = null;
      this.draftEndDate = null;
    }

    this.closeOffcanvas();
    const searchboxValue =
      this.searchForm.value.searchbox?.trim()?.length > 0
        ? this.searchForm.value.searchbox
        : '';

    if (!searchboxValue) {
      this.selectedLocation = null;
      this.placeId = '';
    }

    // If numeric input, navigate directly to property page instead of search
    if (/^\d+$/.test(searchboxValue)) {
      this.router.navigateByUrl(`/rental/${searchboxValue}`);
      return;
    }

    const keyWords =
      searchboxValue.length > 0
        ? searchboxValue
            .replace(/\s+/g, '-')
            .replace(/,+/g, '-')
            .replace(/--+/g, '-')
        : 'Anywhere';

    let params = this.route.snapshot.queryParams;
    const inferredSelection = this.inferSelectionFromParams(
      params,
      String(searchboxValue || ''),
    );
    const effectiveSelection = this.resolveEffectiveSelection(
      this.selectedLocation,
      inferredSelection,
    );

    if (!this.selectedLocation && inferredSelection) {
      this.selectedLocation = inferredSelection;
    }

    const searchParams: any = {
      dates: this.getDatesParam(),
      adults: this.mobileGuests.adults ?? params['adults'] ?? 2,
      children: this.mobileGuests.children ?? params['children'] ?? 0,
      infants: this.mobileGuests.infants ?? params['infants'] ?? 0,
      dateFlexibility: this.dateFlexibility,
      place_id: this.placeId || '',
    };

    if (
      !effectiveSelection &&
      searchboxValue &&
      !/^\d+$/.test(searchboxValue)
    ) {
      searchParams.searchKeyword = searchboxValue;
    }

    if (!effectiveSelection && /^\d+$/.test(searchboxValue)) {
      searchParams.propertyId = Number(searchboxValue);
    }

    if (effectiveSelection?.type === 'region' && effectiveSelection.id) {
      searchParams.regionId = effectiveSelection.id;
    }
    if (effectiveSelection?.type === 'subregion' && effectiveSelection.id) {
      searchParams.subregionId = effectiveSelection.id;
    }
    if (effectiveSelection?.type === 'propertyType' && effectiveSelection.id) {
      searchParams.propertyTypeId = effectiveSelection.id;
    }
    if (
      effectiveSelection?.type === 'keyword' &&
      !/^\d+$/.test(effectiveSelection.name || '')
    ) {
      searchParams.searchKeyword = effectiveSelection.name;
    }
    if (effectiveSelection?.type === 'property' && effectiveSelection.id) {
      searchParams.propertyId = effectiveSelection.id;
    }
    if (effectiveSelection?.type === 'mapping' && effectiveSelection.id) {
      searchParams.mappingId = effectiveSelection.id;
    }

    this.router.navigateByUrl(
      `/search/${keyWords}/rentals?${new URLSearchParams(searchParams).toString()}`,
    );
  }

  onPlacesBoxChange(e): void {
    if (e?.name) {
      this.searchForm.get('searchbox').setValue(e.name);
    }
    this.selectedLocation = null;
    this.placeId = e.place_id;
    this.onSubmit();
  }

  ngOnDestroy(): void {
    this.setHeaderMobileSearchBodyState(false);
    if (this.searchSubmitPulseTimer) {
      clearTimeout(this.searchSubmitPulseTimer);
    }
    // Unsubscribe from all subscriptions
    this.unsubscribeAll.next(null);
    this.unsubscribeAll.complete();
    this.queryParamsSubscription?.unsubscribe();
    this.searchboxValueSubscription?.unsubscribe();
  }

  private syncSearchStateFromParams(params: any): void {
    const searchbox = this.searchForm?.get('searchbox');
    const routePlace = this.getCurrentRoutePlace();
    const queryKeyword = String(params['searchKeyword'] || '').trim();
    const nextSearchboxValue = queryKeyword || routePlace || '';
    const mappingId = this.toPositiveNumber(params['mappingId']);
    const regionId = this.toPositiveNumber(params['regionId']);
    const subregionId = this.toPositiveNumber(params['subregionId']);
    const propertyTypeId = this.toPositiveNumber(params['propertyTypeId']);
    const propertyId = this.toPositiveNumber(params['propertyId']);

    // URL/query params are the source of truth for the where field.
    if (mappingId) {
      this.selectedLocation = {
        type: 'mapping',
        id: mappingId,
        name: nextSearchboxValue,
      };
    } else if (regionId) {
      this.selectedLocation = {
        type: 'region',
        id: regionId,
        name: nextSearchboxValue,
      };
    } else if (subregionId) {
      this.selectedLocation = {
        type: 'subregion',
        id: subregionId,
        name: nextSearchboxValue,
      };
    } else if (propertyTypeId) {
      this.selectedLocation = {
        type: 'propertyType',
        id: propertyTypeId,
        name: nextSearchboxValue,
      };
    } else if (propertyId) {
      this.selectedLocation = {
        type: 'property',
        id: propertyId,
        name: nextSearchboxValue,
      };
    } else if (queryKeyword) {
      this.selectedLocation = {
        type: 'keyword',
        name: queryKeyword,
      };
    } else {
      this.selectedLocation = null;
    }

    this.placeId = String(params['place_id'] || '').trim();

    if (searchbox) {
      searchbox.setValue(nextSearchboxValue, { emitEvent: false });
    }

    this.mobileGuests = {
      adults: Number(params['adults'] ?? 2),
      children: Number(params['children'] ?? 0),
      infants: Number(params['infants'] ?? 0),
    };

    const dates = String(params['dates'] || '');
    const [from, to] = dates.split('_');

    this.mobileStartDate = from ? new Date(from) : null;
    this.mobileEndDate = to ? new Date(to) : null;
    this.dateFlexibility = Number(params['dateFlexibility'] ?? 0);
  }

  private toPositiveNumber(value: any): number | null {
    const numeric = Number(value);
    return Number.isFinite(numeric) && numeric > 0 ? numeric : null;
  }

  private inferSelectionFromParams(
    params: any,
    fallbackName: string,
  ): LocationSelection | null {
    const routePlace = this.getCurrentRoutePlace();
    const queryKeyword = String(params?.['searchKeyword'] || '').trim();
    const name = queryKeyword || fallbackName || routePlace || '';

    const mappingId = this.toPositiveNumber(params?.['mappingId']);
    if (mappingId) {
      return { type: 'mapping', id: mappingId, name };
    }

    const regionId = this.toPositiveNumber(params?.['regionId']);
    if (regionId) {
      return { type: 'region', id: regionId, name };
    }

    const subregionId = this.toPositiveNumber(params?.['subregionId']);
    if (subregionId) {
      return { type: 'subregion', id: subregionId, name };
    }

    const propertyTypeId = this.toPositiveNumber(params?.['propertyTypeId']);
    if (propertyTypeId) {
      return { type: 'propertyType', id: propertyTypeId, name };
    }

    const propertyId = this.toPositiveNumber(params?.['propertyId']);
    if (propertyId) {
      return { type: 'property', id: propertyId, name };
    }

    if (queryKeyword) {
      return { type: 'keyword', name: queryKeyword };
    }

    return null;
  }

  private resolveEffectiveSelection(
    currentSelection: LocationSelection | null,
    inferredSelection: LocationSelection | null,
  ): LocationSelection | null {
    // If URL still carries a structured filter (mapping/region/subregion/etc),
    // prefer it over a transient keyword selection in component state.
    if (
      inferredSelection &&
      inferredSelection.type !== 'keyword' &&
      (!currentSelection || currentSelection.type === 'keyword')
    ) {
      return inferredSelection;
    }

    return currentSelection || inferredSelection;
  }

  private getWhereSummary(): string {
    const routePlace = this.getCurrentRoutePlace();

    return (
      this.selectedLocation?.name ||
      this.searchForm?.get('searchbox')?.value?.trim() ||
      routePlace ||
      'Anywhere'
    );
  }

  private getCurrentRoutePlace(): string {
    if (!this.isSearchRoute()) {
      return '';
    }

    let snapshot: ActivatedRouteSnapshot | null = this.route.snapshot;
    while (snapshot?.firstChild) {
      snapshot = snapshot.firstChild;
    }

    const rawPlace = (snapshot?.paramMap.get('place') || '').trim();
    if (!rawPlace || rawPlace.toLowerCase() === 'anywhere') {
      return '';
    }

    const normalizedPlace = decodeURIComponent(rawPlace)
      .replace(/[-_]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    return normalizedPlace.replace(/\b\w/g, (char) => char.toUpperCase());
  }

  private getWhenSummary(): string {
    // Show draft dates if calendar is open, otherwise show main dates
    const startDate = this.draftStartDate || this.mobileStartDate;
    const endDate = this.draftEndDate || this.mobileEndDate;

    if (!startDate || !endDate) {
      return 'Add dates';
    }

    return `${this.formatShortDate(startDate)} - ${this.formatShortDate(endDate)}`;
  }

  private getDatesParam(): string {
    // Use draft dates if available (calendar is open), otherwise use main dates
    const startDate = this.draftStartDate || this.mobileStartDate;
    const endDate = this.draftEndDate || this.mobileEndDate;

    if (!startDate || !endDate) {
      return '';
    }

    return `${this.toIsoDate(startDate)}_${this.toIsoDate(endDate)}`;
  }

  private toIsoDate(value: Date): string {
    return value.toISOString().split('T')[0];
  }

  private formatShortDate(value: Date): string {
    return value.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
    });
  }

  private getTotalGuests(): number {
    return (
      Number(this.mobileGuests?.adults || 0) +
      Number(this.mobileGuests?.children || 0) +
      Number(this.mobileGuests?.infants || 0)
    );
  }

  openLogin(): void {
    const tolisDialogRef = this._tolisDialogService
      .open(LoginComponent, {
        data: {
          selectedProducts: [],
          multiple: true,
        },
      })
      .afterClosed()
      .subscribe((message) => {});
  }

  openSignupModal(): void {
    const tolisDialogRef = this._tolisDialogService.open(SignupDialog, {
      data: {
        animation: true,
      },
    });

    tolisDialogRef.afterClosed().subscribe((message) => {
      // Subscription runs after the close event

      if (message !== 'fromx') {
        this.ref.detectChanges();
      }
      if (message === 'signup') {
      }
    });
  }

  logout(event: MouseEvent): void {
    // event.preventDefault();
    this.tokenService.remove();
    this.authCheckService.changeAuthStatus(false);
    this.router.navigateByUrl('/');
  }
}
